import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { cloudloyalty } from 'Services/Apis/clients';

export const getCategoriesChips = createAsyncThunk(
  'categoriesChipsReducer/getCategoriesChips',
  async (_, { getState }) => {
    const { user } = getState().oidc;
    try {
      const response = await cloudloyalty(user).get('/v2/products/categories');

      return response.data;
    } catch (error) {
      return { error: error.message };
    }
  }
);

const initialState = {
  isLoading: false,
  items: null,
  error: null,
};

const categoriesChipsReducer = createSlice({
  name: 'categoriesChipsReducer',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getCategoriesChips.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCategoriesChips.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items = action.payload;
        state.error = null;
      })
      .addCase(getCategoriesChips.rejected, (state, action) => {
        state.isLoading = false;
        state.items = null;
        state.error = action?.payload?.error;
      });
  },
});

export const { addNome, removeNome } = categoriesChipsReducer.actions;
export default categoriesChipsReducer.reducer;
